"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  height: 26px;\n  width: 26px;\n  border-radius: ", ";\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-right: 6px;\n\n  html.non-touch &:hover {\n    background-color: ", ";\n  }\n"], ["\n  height: 26px;\n  width: 26px;\n  border-radius: ", ";\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-right: 6px;\n\n  html.non-touch &:hover {\n    background-color: ", ";\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  ", ";\n  color: ", ";\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  ", ";\n  color: ", ";\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  user-select: none;\n"], ["\n  display: flex;\n  align-items: center;\n  user-select: none;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

var _Caret = require("./images/Caret");

var _Caret2 = _interopRequireDefault(_Caret);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Item = _styledComponents2.default.div.withConfig({
  displayName: "src__Item",
  componentId: "mbit31-0"
})(_templateObject, _buoyTheme.constants.borderRadius, function (props) {
  return props.active ? _buoyTheme.colors.primaryLightest(props) : "white";
}, _buoyTheme.colors.primaryLightest);

var Text = _styledComponents2.default.span.withConfig({
  displayName: "src__Text",
  componentId: "mbit31-1"
})(_templateObject2, _buoyTheme.fontFamily, _buoyTheme.fontWeight.normal, (0, _buoyTheme.fontSize)('bodyMain'), function (props) {
  return props.active ? _buoyTheme.colors.primary(props) : _buoyTheme.colors.neutral(props);
});

var Container = _styledComponents2.default.div.withConfig({
  displayName: "src__Container",
  componentId: "mbit31-2"
})(_templateObject3);

var Page = function Page(props) {
  return _react2.default.createElement(
    Item,
    props,
    _react2.default.createElement(
      Text,
      props,
      props.text
    )
  );
};

var calcOffset = function calcOffset(pages, active, max) {
  if (pages > max) {
    // Always show 8 pages if they exist
    if (pages - active < max - 1) {
      // If we're on the last 8 pages, show the last 8 pages
      return pages - max;
    } else if (active > 1) {
      // Leave the page previous
      return active - 2;
    }
  }

  return 0;
};

var Paginate = function Paginate(_ref) {
  var pages = _ref.pages,
      active = _ref.active,
      _onClick = _ref.onClick,
      max = _ref.max,
      props = _objectWithoutProperties(_ref, ["pages", "active", "onClick", "max"]);

  var offset = calcOffset(pages, active, max);
  return _react2.default.createElement(
    Container,
    null,
    active > 1 && _react2.default.createElement(_Caret2.default, { back: true, onClick: function onClick() {
        return _onClick(active - 1);
      } }),
    [].concat(_toConsumableArray(new Array(pages > max ? max : pages))).map(function (x, i) {
      return _react2.default.createElement(Page, {
        text: offset + i + 1,
        key: offset + i + 1,
        active: active === i + offset + 1,
        onClick: function onClick() {
          return _onClick(i + offset + 1);
        }
      });
    }),
    active < pages && _react2.default.createElement(_Caret2.default, { onClick: function onClick() {
        return _onClick(active + 1);
      } })
  );
};

exports.default = Paginate;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-pagination/dist/index.js
// module id = 433
// module chunks = 168707334958949